class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    const currentHandle = this.dataset.currentProduct;
    const productsToShow = parseInt(this.dataset.productsToShow) || 4;

    let products = [];
    try {
      products = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
    } catch (e) {
      return;
    }

    if (currentHandle) {
      products = products.filter((p) => p.handle !== currentHandle);
    }

    products = products.slice(0, productsToShow);

    if (products.length === 0) {
      this.style.display = 'none';
      return;
    }

    const list = this.querySelector('ul');
    if (!list) return;

    products.forEach((product) => {
      const li = document.createElement('li');
      li.className = 'grid__item';
      li.innerHTML = this._renderCard(product);
      list.appendChild(li);
    });
  }

  _renderCard(product) {
    const saleHtml =
      product.compare_at_price
        ? `<div class="price__sale">
            <span class="visually-hidden">通常価格</span>
            <span><s class="price-item price-item--regular">${product.compare_at_price}</s></span>
            <span class="visually-hidden">セール価格</span>
            <span class="price-item price-item--sale price-item--last">${product.price_formatted}</span>
          </div>`
        : `<div class="price__regular">
            <span class="visually-hidden">通常価格</span>
            <span class="price-item price-item--regular">${product.price_formatted}</span>
          </div>`;

    const imgHtml = product.image
      ? `<img src="${product.image}" alt="${product.image_alt}" loading="lazy" class="motion-reduce">`
      : '';

    return `<div class="card-wrapper product-card-wrapper underline-links-hover">
      <div class="card card--standard card--media">
        <div class="card__inner color-scheme-1 gradient ratio" style="--ratio-percent: 100%;">
          <div class="card__media">
            <div class="media media--transparent media--hover-effect">
              <a href="${product.url}" tabindex="-1">${imgHtml}</a>
            </div>
          </div>
          <div class="card__content">
            <div class="card__badge top left"></div>
          </div>
        </div>
        <div class="card__content">
          <div class="card__information">
            <h3 class="card__heading h5">
              <a href="${product.url}" class="full-unstyled-link">${product.title}</a>
            </h3>
            <div class="card-information">
              <div class="price">
                <div class="price__container">${saleHtml}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>`;
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
